import {createMapper} from '@automapper/core';
import {pojos} from '@automapper/pojos';
import type {IMapping} from '@igp/shared/auto-mapper';
import {BackpackMapping} from '@igp/shared/features/backpack';
import {BoUserGroupMapping} from '@igp/shared/features/bo-user-group';
import {BonusCodeMapping} from '@igp/shared/features/bonus-code';
import {LicenseMapping} from '@igp/shared/features/brand-license';
import {LabelMapping} from '@igp/shared/features/label';
import {P2PGlobalSettingsMapping} from '@igp/shared/features/p2p-global-settings';
import {P2PPlayerSettingsMapping} from '@igp/shared/features/p2p-player-settings';
import {PlayerBonusMapping} from '@igp/shared/features/player-bonus';
import {TransactionMapping} from '@igp/shared/features/transaction';
import {UserActivitySummaryMapping} from '@igp/shared/features/user-activity-summary';
import {UserProfileMapping} from '@igp/shared/features/user-profile';

import {AgentLevelReportV2Mapping} from '@features/agent-level-report-v2';
import {BoUserMapping} from '@features/bo-user';
import {CountryLevelPartnerReportMapping} from '@features/country-level-partner-report';
import {DebtResponsibleMasterAgentMapper} from '@features/debt-responsible-master-agent';
import {DebtTransferLogMapping} from '@features/debt-transfer-log';
import {KeycloakLogMapping} from '@features/keycloak-log';
import {NegativeCarryoverReportMapping} from '@features/negative-carryover-report';
import {PayoutReportMapping} from '@features/payout-report';
import {PlayerEcologyWeeklyMapping} from '@features/player-ecology-weekly';
import {PlayerLevelReportV2Mapping} from '@features/player-level-report-v2';
import {ReferralLinkConfigMapping} from '@features/referral-link-config';
import {RepaymentLogMapper} from '@features/repayment-log';

export function initAutoMapper() {
    const mapper = createMapper({
        strategyInitializer: pojos(),
    });

    const mappings: IMapping[] = [
        new LabelMapping(),
        new UserProfileMapping(),
        new TransactionMapping(),
        new AgentLevelReportV2Mapping(),
        new PlayerLevelReportV2Mapping(),
        new NegativeCarryoverReportMapping(),
        new UserActivitySummaryMapping(),
        new PlayerBonusMapping(),
        new BonusCodeMapping(),
        new BackpackMapping(),
        new CountryLevelPartnerReportMapping(),
        new DebtResponsibleMasterAgentMapper(),
        new DebtTransferLogMapping(),
        new KeycloakLogMapping(),
        new RepaymentLogMapper(),
        new PayoutReportMapping(),
        new BoUserMapping(),
        new BoUserGroupMapping(),
        new P2PGlobalSettingsMapping(),
        new P2PPlayerSettingsMapping(),
        new PlayerEcologyWeeklyMapping(),
        new ReferralLinkConfigMapping(),
        new LicenseMapping(),
    ];
    mappings.forEach(m => m.createMapping(mapper));

    return mapper;
}
